import templates from "../moked/templates.json";
import categories from "../moked/categories.json";
import tags from "../moked/tags.json";

const GET_TEMPLATE_REQUEST = "FARMAKOM/EDITOR/GET_TEMPLATE_REQUEST";
const GET_TEMPLATE_SUCCESS = "FARMAKOM/EDITOR/GET_TEMPLATE_SUCCESS";
const GET_TEMPLATE_FAILURE = "FARMAKOM/EDITOR/GET_TEMPLATE_FAILURE";

const initialState = {
  loading: false,
  error: false,
  singleTemplate: {
    ...templates[0],
    categories,
    categoryTags: tags,
  },
  data: templates.map((temp) => {
    return {
      ...temp,
      categories,
      categoryTags: tags,
    };
  }),
};

export default function reducerTemplates(state = initialState, action) {
  switch (action.type) {
    case GET_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        // singleStore: null
      };
    case GET_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        singleTemplate: {
          ...action.payload,
          categories,
          categoryTags: tags,
        },
      };
    case GET_TEMPLATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

export const getTemplateById = (templateId) => {
  return (dispatch) => {
    dispatch({
      type: GET_TEMPLATE_REQUEST,
    });

    // console.log("temp", templateId);
    const template = templates.find((templ) => templ.storeId == templateId);

    if (template) {
      // console.log("qui");
      dispatch({
        type: GET_TEMPLATE_SUCCESS,
        payload: template,
      });
    } else {
      // console.log("quo");
      dispatch({
        type: GET_TEMPLATE_FAILURE,
        payload: "Couldn't find template",
      });
    }
  };
};
